import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

/* ─── Types ──────────────────────────────────────────────────────────── */

interface AddBankDepositArgs {
  branchId:     string;
  bankId:       string;
  amount:       number;
  receiptImage: string;
  remark?:      string;
}

interface GetBankDepositHistoryParams {
  accountNumber: string;
  startDate?:    string;
  endDate?:      string;
  page?:         number;
  limit?:        number;
}

interface GetAllBankDepositsParams {
  page?:  number;
  limit?: number;
}

/* ─── API ────────────────────────────────────────────────────────────── */

export const bankDepositApi = createApi({
  reducerPath: 'bankDepositApi',
  baseQuery:   dynamicBaseQuery,
  tagTypes:    ['BankDeposit'] as const,
  endpoints:   (builder) => ({
    addBankDeposit: builder.mutation<unknown, AddBankDepositArgs>({
      query: (body) => ({ url: `/bank-deposits`, method: 'POST', body }),
      invalidatesTags: ['BankDeposit'],
    }),
    getBankDepositHistory: builder.query<unknown, GetBankDepositHistoryParams>({
      query: ({ accountNumber, startDate, endDate, page, limit }) => {
        const qp = new URLSearchParams();
        if (startDate)      qp.append('startDate', startDate);
        if (endDate)        qp.append('endDate', endDate);
        if (page  != null)  qp.append('page', String(page));
        if (limit != null)  qp.append('limit', String(limit));
        const qs = qp.toString();
        return { url: qs ? `/bank-deposits/account/${accountNumber}?${qs}` : `/bank-deposits/account/${accountNumber}`, method: 'GET' };
      },
      providesTags: ['BankDeposit'],
    }),
    getAllBankDeposits: builder.query<unknown, GetAllBankDepositsParams | void>({
      query: (params) => {
        const { page, limit } = params || {};
        const qp = new URLSearchParams();
        if (page  != null) qp.append('page', String(page));
        if (limit != null) qp.append('limit', String(limit));
        const qs = qp.toString();
        return { url: qs ? `/bank-deposits?${qs}` : `/bank-deposits`, method: 'GET' };
      },
      providesTags: ['BankDeposit'],
    }),
  }),
});

export const { useAddBankDepositMutation, useGetBankDepositHistoryQuery, useGetAllBankDepositsQuery } = bankDepositApi;
